import { useQuery } from "@tanstack/react-query";
import { authClient } from "../auth-client";
import type { components } from "../types";

type IntegrationResponse = components["schemas"]["IntegrationResponse"];
type AppIntegrationResponse = components["schemas"]["AppIntegrationResponse"];

/**
 * Fetch all user integrations
 */
export function useIntegrations() {
	return useQuery({
		queryKey: ["integrations"],
		queryFn: async () => {
			const { data, error, response } = await authClient.GET("/api/v1/integrations/");

			if (error) {
				// Throw error with response for proper categorization
				throw { error, response };
			}

			return data as IntegrationResponse[];
		},
	});
}

/**
 * Fetch integration catalog (all available integrations)
 */
export function useIntegrationCatalog(options?: { enabled?: boolean }) {
	return useQuery({
		queryKey: ["integration-catalog"],
		queryFn: async () => {
			const { data, error, response } = await authClient.GET("/api/v1/integrations/catalog");

			if (error) {
				// Throw error with response for proper categorization
				throw { error, response };
			}

			return data as AppIntegrationResponse[];
		},
		enabled: options?.enabled ?? true,
	});
}
